import axios from 'axios'
import { makeTokenRefresher } from './tokenRefresh'
import { defaultApiBase } from './apiBase'
import useAuthStore from '../store/authStore'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || defaultApiBase()

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const refreshAccessToken = makeTokenRefresher({
  doRefresh: (refresh) =>
    axios
      .post(`${API_BASE_URL}/auth/token/refresh/`, { refresh })
      .then((r) => r.data.access),
  storage: localStorage,
  onSessionExpired: () => {
    // pulisce anche lo stato persistito in Zustand (auth-storage): senza,
    // isAuthenticated restava "true" lì anche a token rimossi, e LoginPage/
    // ProtectedRoute - che si fidano di quello stato, non di localStorage -
    // rimbalzavano la pagina avanti e indietro tra /login e /dashboard
    useAuthStore.getState().logout()
    window.location.href = '/login'
  },
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        const access = await refreshAccessToken()
        originalRequest.headers.Authorization = `Bearer ${access}`
        return api(originalRequest)
      } catch (refreshError) {
        // sessione chiusa (se il refresh token era invalido) o errore
        // transitorio (429/rete): in entrambi i casi la richiesta originale
        // fallisce e chi l'ha fatta mostra il suo errore
      }
    }
    return Promise.reject(error)
  }
)

export default api
